import React from 'react';
import { Select, Form, Input } from 'antd';
import { H_B_H_LEVELS, OTHER_LEVEL_CODE } from '@/constants';

const { Option } = Select;

function SelectActivityLevel() {
  return (
    <>
      <Form.Item hidden label="货币化级别" name="monetizedLevel">
        <Select placeholder="请选择">
          {H_B_H_LEVELS.slice(1).map((item) => (
            <Option key={item.val} value={item.val}>
              {item.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item shouldUpdate={(prevValue, curValue) => prevValue.monetizedLevel !== curValue.monetizedLevel} noStyle>
        {({ getFieldValue }) => {
          return getFieldValue('monetizedLevel') === OTHER_LEVEL_CODE ? (
            <Form.Item
              wrapperCol={{ style: { marginLeft: '143px', flexGrow: 0, flexBasis: '380px' } }}
              rules={[
                {
                  required: true,
                  message: '货币化级别不可为空',
                },
                {
                  max: 50,
                  message: '货币化级别不能超过50个字符',
                },
              ]}
              name="hbhOtherLevel"
            >
              <Input placeholder="请输入50字以内的货币化级别" />
            </Form.Item>
          ) : null;
        }}
      </Form.Item>
    </>
  );
}

export default SelectActivityLevel;
